import angular from "angular";
import HomeLandingWorkAreaSectionComponent from "./home-landing-work-area.component";
import LandingPageModule from "../../../../components/landing-page/landing-page.module";
import ServiceProvidersPublicApi from "../../../../resources/service-providers/public-service-providers.resource";

export default angular.module("vt-public-home-landing-work-area.module", [
    LandingPageModule.name,
    ServiceProvidersPublicApi.name
]).component("homeLandingWorkAreaSection", HomeLandingWorkAreaSectionComponent);
